
// This file is auto-generated by generate-programs-data.js. Do not edit manually.
const availablePrograms = [
  {
    "accordion_title": "Infant Program Details",
    "age": "6 Weeks - 19 Mo",
    "start": 1.5,
    "end": 15,
    "img": "/programs_images/infant.png",
    "bg_color": "grass",
    "dropdownData": [
      {
        "title": "Price",
        "description": "5 Days Starting at $345.00 WK",
        "color": "carrot"
      },
      {
        "title": "Description",
        "description": "Your infant's experience at Brighter Beginnings Child Care L.L.C. is tailored to their unique needs and development. We provide personalized nap schedules and cozy cribs equipped with your provided sleep sack and bedding (no blankets). Infants typically enjoy two naps a day and have designated times for snacks and breakfast at an infant table with secure seating. You're encouraged to bring your infants's snacks and lunch- keep in mind we don't use microwaves, we do provide fridge space. Whole milk is provided. Your infant will love daily outdoor strolls, engaging books, and stimulating toys. Our caregivers also read to them, fostering early language development in our nurturing environment.",
        "color": "sky"
      },
      {
        "title": "Schedule",
        "description": "During intake, parents and the infant’s educator will write up a schedule altered to that particular infant. Infant schedules are individual and may change as the needs of the infant changes",
        "color": "grass"
      }
    ]
  },
  {
    "accordion_title": "Toddler Program Details",
    "age": "16 Mo - 2.9 Yrs",
    "start": 16,
    "end": 34,
    "img": "/programs_images/toddler.png",
    "bg_color": "sky",
    "dropdownData": [
      {
        "title": "Price",
        "description": "5 Days Starting at $320.00 Wk",
        "color": "carrot"
      },
      {
        "title": "Description",
        "description": "Your toddler builds on the foundations established in our Infant Class, focusing on independence and exploration. After lunch, they take a (1) daily nap on mats where we ask you provide the bedding. Mealtime is structured, with each child having an assigned chair at a table for snacks and lunch. We ask that parents provide all meals- keep in mind we don't have microwaves, we do provide fridge space. Whole milk is available. Your toddler will enjoy sensory activities, including art projects and sensory play with sand, water, and more. They will participate in storytime, sing-alongs, and plenty of outdoor play in our safe play areas, ensuring a stimulating day.",
        "color": "sky"
      },
      {
        "title": "Schedule",
        "description": "toddler schedule",
        "color": "grass"
      }
    ]
  },
  {
    "accordion_title": "Pre-School Program Details",
    "age": "2.9 Yrs - 5 Yrs",
    "start": 34.1,
    "end": 59,
    "img": "/programs_images/pre_school.png",
    "bg_color": "sun",
    "dropdownData": [
      {
        "title": "Price",
        "description": "5 Days starting at $245.00 Wk, 3 Days starting at $159.00 Wk, 2 Days starting at $113.00 Wk",
        "color": "carrot"
      },
      {
        "title": "Description",
        "description": "Your preschooler will thrive in our comprehensive educational environment, promoting physical, social, emotional, and language development. Our curriculum revolves around monthly themes and emergent learning concepts, encouraging diverse experiences and self-expression. Weekly activities include English Language Arts, Science and Technology, History and Social Science, Comprehensive Health, The Arts, Music, Creative Movement, Pre-reading, and Mathematics. Indoor and outdoor gross motor play are integral, fostering self-help skills, independence, and self-regulation for your preschooler. Parents provide snacks and lunch- keep in mind we don't have microwaves, we do provide fridge space.",
        "color": "sky"
      },
      {
        "title": "Schedule",
        "description": "preschool schedule",
        "color": "grass"
      }
    ]
  }
];

export default availablePrograms;
